module.exports = __webpack_public_path__ + "img/Before_filesName.37b7e6f0.png";